import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaBlock } from '../CtaButton';
import { SectionHeading } from './SectionHeading';
import { offerIncludes } from '../../data/content';
import { MOCKUP_URL } from '../../data/images';

/** The offer — the only block with the price and the real checkout button. */
export function OfferSection() {
  return <section id="offer" aria-labelledby="offer-heading" className="scroll-mt-4 bg-brand-oatmeal px-5 py-16 lg:px-8 lg:py-24" data-id="element-99" data-mp="1fmmepm1myzg1">
      <div className="mx-auto max-w-5xl" data-id="element-100" data-mp="288ys0ra9606t">
        <SectionHeading id="offer-heading" title="Deine Unterrichtsmaterialien. Einmal kaufen. Digital nutzen." data-id="element-101" data-mp="28a0bnk5c3v05" />

        <div className="mx-auto mt-12 max-w-4xl overflow-hidden rounded-[28px] border-2 border-brand-gold/50 bg-white shadow-[0_50px_100px_-50px_rgba(78,49,108,0.55)]" data-id="element-102" data-mp="23g5na3esaruq">
          <div className="bg-brand-forest px-6 py-4 text-center" data-id="element-103" data-mp="2w0ch8od3xfnk">
            <p className="font-body text-[12px] font-bold uppercase tracking-[0.2em] text-brand-ivory" data-id="element-104" data-mp="2r7t4tuq5oqkc">
              Nail Educator Ready™ — Deutsche Ausgabe
            </p>
          </div>

          <div className="px-6 py-10 sm:px-12" data-id="element-105" data-mp="3hhedmtkdpvv7">
            <img src={MOCKUP_URL} alt="Alles, was in Nail Educator Ready enthalten ist" width={1536} height={1024} loading="lazy" decoding="async" className="mx-auto block w-full max-w-[460px] object-contain" style={{
            filter: 'drop-shadow(0 24px 28px rgba(78, 49, 108, 0.2))'
          }} data-id="element-106" data-mp="3hg3a8uuuiq4m" />

            <p className="mt-10 text-center font-body text-[12px] font-bold uppercase tracking-[0.18em] text-brand-gold" data-id="element-107" data-mp="2yoai12nlp8xy">
              6 digitale Fachbände
            </p>
            <ul className="mx-auto mt-5 grid max-w-xl gap-y-3.5" role="list" data-id="element-108" data-mp="2osz42mk0o5r9">
              {offerIncludes.map(item => <li key={item} className="flex items-center gap-3 text-[15px] leading-snug text-brand-charcoal sm:text-[16px]" data-id="element-109" data-mp="ix4s8ywsff1u">
                  <CheckIcon className="h-4 w-4 flex-none text-brand-cta" strokeWidth={2.5} aria-hidden="true" data-id="element-110" data-mp="1vxj4p7hta71k" />
                  {item}
                </li>)}
            </ul>

            <div className="mt-10 border-t border-brand-charcoal/10 pt-9" data-id="element-111" data-mp="1mx34c6wd7g0x">
              <CtaBlock label="Jetzt kaufen & digital herunterladen" showPrice data-id="element-112" data-mp="1mxcsdoxund3z" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}